// import Banner from './Banner';
import React from 'react';
import { connect } from 'react-redux';
import { Card, Row, Col, Button, Carousel, Form, Checkbox, Input, Divider, Alert, Upload } from 'antd';
import TextLoop from 'react-text-loop';
import { LeftOutlined, ArrowLeftOutlined, UploadOutlined } from '@ant-design/icons';
import agent from '../../agent'
import {
  LOGIN,
  LOGIN_PAGE_UNLOADED
} from '../../constants/actionTypes';


import openNotification from '../../components/Notification/Notificaiton';

const mapStateToProps = state => ({
  ...state.home,
  appName: state.common.appName,
  token: state.common.token,
  username: state.common.username,
  authMessage: state.auth.errors
});


const mapDispatchToProps = (dispatch) => ({
  authenticateUser: (data) =>
    // dispatch({ type: LOGIN, payload: agent.Auth.login(data.username, data.password, data.cert_path, data.cert) }),
    dispatch({ type: LOGIN, payload: agent.Auth.login(data.username, data.password, data.cert) }),
  onUnload: () => dispatch({ type: LOGIN_PAGE_UNLOADED }),
});


class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      btnSize: "small",
      checked: true,
      // filepath: '',
      UserCert : '',
    };
  }

  toggleChecked = () => {
    this.setState({ checked: !this.state.checked });
  };

  uploadCert = async (options) => {
    const { onSuccess, onError, file } = options;
    // try {
    //   var response = await agent.TwoFactor.uploadCert(file)

    //   this.setState({ filepath: response.data.upload_path });
    //   onSuccess(response.message)

    // } catch (error) {
    //   onError(response.message)
    //   onError({ error });
    // }
    setTimeout(() =>{
      onSuccess("Ok")
    },10)
  };
  
  readUserCert= (file) => {
    const reader = new FileReader();
    
    reader.onload = e => {
      console.log(e.target.result);
      this.setState({userCert: e.target.result});
    };
    var cert = reader.readAsText(file);

  }


  handleSubmit = (formData) => {

    var formKeys = ["username", "password"];
    if (formData.hasOwnProperty(formKeys[0])
      && formData.hasOwnProperty(formKeys[1])) {
      if  (formData[formKeys[0]].trim() !== ""
        && formData[formKeys[1]].trim() !== "") {
          // let loginData = { ...formData, cert_path: this.state.filepath, cert: this.state.userCert }
          let loginData = { ...formData, cert: this.state.userCert }
          this.props.authenticateUser(loginData);
      }
    }
  };

  componentWillMount() { }
  componentDidMount() {
    let token = window.localStorage.getItem('jwt')
    if (token) {
      // window.sessionStorage.getItem('jwt')
      this.props.history.push('/report')
    } 
    document.title = this.props.title;
  }
  componentWillUnmount() { }
  componentDidUpdate() { }
  componentWillReceiveProps(nextProps) {

    if (nextProps.authMessage) {
      openNotification({ type: 'error', message: 'Error', description: nextProps.authMessage })
    }
  }
  componentDidUpdate(prevProps, prevState) { }


  render() {
    return (
      <div>
        <div className="loginContainer">
          <Row gutter={0} className="height_100">
            <Col span={12} className="loginPanel">
              <div>
                <img src="./images/logo.svg" className="loginLogo" />
                <h1 id="TextAtLogonPage">{this.state.checked ? 'Administration of API Builder' : 'Forgot your password?'}</h1>
                {/* {this.state.checked ? */}
                <Form
                  size="large"
                  name="loginForm"
                  initialValues={{ remember: true }}
                  layout="vertical"
                  onFinish={this.handleSubmit}
                // onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    label="Username"
                  >
                    <Form.Item
                      noStyle
                      name="username"
                      rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                      <Input autoComplete="off"/>
                    </Form.Item>
                  </Form.Item>
                  <Form.Item
                    label="Password"
                  >
                    <Form.Item
                      noStyle
                      name="password"
                      rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                      <Input.Password />
                    </Form.Item>
                  </Form.Item>
                  {/* <Row justify="space-between">
                    <Col>
                      <Form.Item name="remember" valuePropName="checked">
                        <Checkbox>Remember me</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item name="remember" valuePropName="checked">
                        <Button type="link" onClick={this.toggleChecked}>Forgot password?</Button>
                      </Form.Item>
                    </Col>
                  </Row> */}
                  <Form.Item
                    name="loginCert"
                    label="Upload Certification"
                    valuePropName="certList"
                    // getValueFromEvent={this.uploadCertEvent}
                    extra="Please upload your certificate, or contact your administrator for more information."
                    hidden={this.props.twoFactorStatus}
                  >
                    <Upload
                     customRequest={this. uploadCert}
                     accept=".txt, .csv, .pem, .key"
                     showUploadList={true}
                     maxCount={1}
                      beforeUpload={this.readUserCert}
                    >
                      <Button icon={<UploadOutlined />}>Click to upload</Button>
                    </Upload>
                  </Form.Item>
                  <Form.Item >
                    <Button block type="danger" size="large" htmlType="submit">
                      Sign In
                    </Button>
                  </Form.Item>
                  {/* <Divider></Divider> */}
                </Form>
                {/* :
                  <React.Fragment>
                    <Form
                      size="large"
                      name="forgotPasswordForm"
                      layout="vertical"
                    >
                      <Form.Item >
                        <Form.Item
                          label="Email"
                          name="email"
                          rules={[{ required: false, message: 'Please input your email!' }]}
                        >
                          <Input />
                        </Form.Item>
                        <Button block type="danger" size="large" htmlType="submit" >
                          Submit
                        </Button>
                      </Form.Item>
                    </Form>
                    <Divider></Divider>
                    <Row justify="end">
                      <Col>
                        <Button type="text" onClick={this.toggleChecked} icon={<ArrowLeftOutlined />}> Back to login page</Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                } */}

              </div>
            </Col>
            <Col span={12} className="loginTextContainer">
              <div className="inner">
                <h2>Welcome to <b>Companies Registry</b></h2>
                <Divider style={{ borderColor: '#ffff' }}></Divider>
                <TextLoop noWrap={false} mask={true}>
                  <div>To achieve world-wide recognition as an excellent Companies Registry giving the community a quality service.</div>
                  <div>To care for and respect our customers by listening to them and taking into account their needs and expectations when shaping the types and quality of service which we deliver.</div>
                  <div>To care for and respect our colleagues as a quality service and effective enforcement can be delivered and undertaken only through dedicated people of high calibre working together as a team.</div>
                  <div>To change for the better by remaining receptive to new ideas, technologies and work practices so as to enhance the level and quality of our services and facilities.</div>
                </TextLoop>
              </div>
              <Carousel effect="fade" autoplay>
                <div>
                  <img src="./images/slider/1.jpg" />
                </div>
                <div>
                  <img src="./images/slider/2.jpg" />
                </div>
              </Carousel>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// src/layouts/views/login.js